import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { storageLocationColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiStorageLocation } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { StorageLocationsRepository } from '@Repositories/Stammdaten';

export function FrameListStorageLocation() {
    const hasPermission = useHasPermission();

    const module = useListApi(StorageLocationsRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiStorageLocation>
            layoutSettingsContext={EnumFrontendLayoutSetting.StorageLocationsTableLayout}
            name="StorageLocationList"
            columns={storageLocationColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenStorageLocationCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
